<template>
    <div>
        <header-guest></header-guest>
        <div class="alto">
            <slot/>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Headerguest from "./header/header-guest.vue";
import AppFooter from "./footer/footer.vue";

export default {
  components: {
    "app-footer": AppFooter,
    "header-guest": Headerguest,
  },
};
</script>

<style scoped>
@media only screen and (max-height: 900px) {
  .alto {
    min-height: 60vh;
  }
}
@media only screen and (max-height: 1000px) {
  .alto {
    min-height: 78vh;
  }
}

@media only screen and (min-height: 1001px) {
  .alto {
    min-height: 85vh;
  }
}
@media only screen and (min-height: 2001px) {
  .alto {
    min-height: 90vh;
  }
}
</style>